import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./ModalRb.css";

function ModalRb({
  show,
  onHide,
  Modalheading,
  ModalMainBody,
  hideCloseIcon = false,
  dialogClassName = "",
  contentClassName = "",
  customiseMainModalClass = "",
  maxWidth = "md",
  fullWidth = true,
}) {
  const isAutomationFilterModal = dialogClassName?.includes(
    "automation-filter-modal"
  );

  const paperClassName = [
    "modal-rb-paper",
    "modal-rb-content",
    contentClassName,
    dialogClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Dialog
      open={Boolean(show)}
      onClose={onHide || undefined}
      maxWidth={isAutomationFilterModal ? false : maxWidth}
      fullWidth={!isAutomationFilterModal && fullWidth}
      scroll="paper"
      disableScrollLock={false}
      aria-labelledby="modal-rb-title"
      PaperProps={{
        className: paperClassName,
        elevation: 0,
        sx: {
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 16px 48px rgba(15, 23, 42, 0.16)",
          border: "1px solid #E5E7EB",
          ...(isAutomationFilterModal
            ? {
                width: "auto",
                maxWidth: "min(920px, calc(100vw - 32px))",
                minWidth: { xs: "calc(100vw - 32px)", sm: 420 },
              }
            : {}),
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(15, 23, 42, 0.45)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
    >
      <DialogTitle
        id="modal-rb-title"
        className="modal-header"
        sx={{
          m: 0,
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          borderBottom: "1px solid #EEF0F3",
          bgcolor: "#FAFBFC",
          minHeight: 56,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            px: hideCloseIcon ? 0 : 4,
          }}
        >
          {typeof Modalheading === "string" ||
          typeof Modalheading === "number" ? (
            <Typography
              component="h2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#111827",
                lineHeight: 1.4,
                letterSpacing: "-0.01em",
                m: 0,
              }}
            >
              {Modalheading}
            </Typography>
          ) : (
            Modalheading
          )}
        </Box>

        {!hideCloseIcon && (
          <IconButton
            aria-label="Close"
            onClick={onHide}
            size="small"
            className="modal-rb-close-icon"
            sx={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#6B7280",
              bgcolor: "transparent",
              "&:hover": {
                bgcolor: "rgba(17, 24, 39, 0.06)",
                color: "#111827",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent
        dividers
        className={["modal-body", customiseMainModalClass]
          .filter(Boolean)
          .join(" ")}
        sx={{
          px: 3,
          py: 2.5,
          bgcolor: "#FFFFFF",
          "&.MuiDialogContent-dividers": {
            borderTop: "none",
            borderBottom: "none",
          },
        }}
      >
        <Box className="modal-rb-body-inner">{ModalMainBody}</Box>
      </DialogContent>
    </Dialog>
  );
}

export default ModalRb;
